import { updateUtrNumberDataRequest } from "@/redux/actions";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Divider, Drawer, Grid, IconButton, TextField, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { config } from "../../../config";
const FinalChargesSliderbarPage = ({ isOpen, setIsExportSidebarOpen, selecteFinalCharges, setSelectedFinalCharges, selectedBillingCycle, setIsBackOpenOpen, }) => {
    const [utrNumber, setUtrNumber] = React.useState("");
    const dispatch = useDispatch();
    const UtrNumberState = useSelector((state) => state.UpdateUtrNumberReducer);
    const primaryColor = config.theme.primaryColor;
    const toggleDrawer = () => {
        setIsExportSidebarOpen(false);
    };
    const handleSave = () => {
        setIsBackOpenOpen(true);
        dispatch(updateUtrNumberDataRequest({
            billingCycle: selectedBillingCycle,
            tenantId: selecteFinalCharges.tenantId,
            utrNumber: utrNumber,
        }));
    };
    React.useEffect(() => {
        if (UtrNumberState.updateData !== "") {
            enqueueSnackbar("UtrNumber updated successful", {
                variant: "success",
            });
            setIsBackOpenOpen(false);
        }
        else if (UtrNumberState.error) {
            if (UtrNumberState.error instanceof Error) {
                enqueueSnackbar(UtrNumberState.error.message, {
                    variant: "error",
                });
            }
            setIsBackOpenOpen(false);
        }
    }, [UtrNumberState]);
    return (React.createElement(Drawer, { open: isOpen, anchor: "right", onClose: toggleDrawer, PaperProps: { sx: { width: 500 } } },
        React.createElement(Box, { sx: { padding: 3, height: "100%", backgroundColor: "#f9f9f9" } },
            React.createElement(Box, { sx: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2 } },
                React.createElement(Typography, { variant: "h6", component: "div", sx: { fontWeight: "bold" } }, "Other details"),
                React.createElement(IconButton, { onClick: toggleDrawer, size: "small" },
                    React.createElement(CloseIcon, null))),
            React.createElement(Divider, { sx: { marginBottom: 3 } }),
            React.createElement(Box, { component: "form", noValidate: true, autoComplete: "off" },
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { className: "m_form_label_font", variant: "body2", gutterBottom: true }, "Whatsapp"),
                        React.createElement(TextField, { InputLabelProps: { shrink: false }, inputProps: { maxLength: 30, minLength: 2, readOnly: true }, placeholder: "Whatsapp", fullWidth: true, name: "Whatsapp", size: "small", sx: {
                                "& .MuiInputBase-root": {
                                    backgroundColor: "#EFEFEF",
                                },
                            }, value: selecteFinalCharges.whatsappEnabled ? "Yes" : "No" })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { className: "m_form_label_font", variant: "body2", gutterBottom: true }, "Flates rate"),
                        React.createElement(TextField, { InputLabelProps: { shrink: false }, inputProps: { maxLength: 30, minLength: 2, readOnly: true }, placeholder: "flatRates", fullWidth: true, name: "flatRates", size: "small", sx: {
                                "& .MuiInputBase-root": {
                                    backgroundColor: "#EFEFEF",
                                },
                            }, value: selecteFinalCharges.flatRateEnabled ? "Yes" : "No" })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { className: "m_form_label_font", variant: "body2", gutterBottom: true }, "Account name"),
                        React.createElement(TextField, { InputLabelProps: { shrink: false }, inputProps: { maxLength: 30, minLength: 2, readOnly: true }, placeholder: "Account name", fullWidth: true, name: "accountName", size: "small", sx: {
                                "& .MuiInputBase-root": {
                                    backgroundColor: "#EFEFEF",
                                },
                            }, value: selecteFinalCharges.bankAccountName })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { className: "m_form_label_font", variant: "body2", gutterBottom: true }, "Bank name"),
                        React.createElement(TextField, { InputLabelProps: { shrink: false }, inputProps: { maxLength: 30, minLength: 2, readOnly: true }, placeholder: "Bank name", fullWidth: true, name: "bankName", size: "small", sx: {
                                "& .MuiInputBase-root": {
                                    backgroundColor: "#EFEFEF",
                                },
                            }, value: selecteFinalCharges.bankName })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { className: "m_form_label_font", variant: "body2", gutterBottom: true }, "Account number"),
                        React.createElement(TextField, { InputLabelProps: { shrink: false }, inputProps: { maxLength: 30, minLength: 2, readOnly: true }, placeholder: "Account number", fullWidth: true, name: "amountNumber", size: "small", sx: {
                                "& .MuiInputBase-root": {
                                    backgroundColor: "#EFEFEF",
                                },
                            }, value: selecteFinalCharges.bankAccountNumber })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { className: "m_form_label_font", variant: "body2", gutterBottom: true }, "IFSC code"),
                        React.createElement(TextField, { InputLabelProps: { shrink: false }, inputProps: { maxLength: 30, minLength: 2, readOnly: true }, placeholder: "IFSC code", fullWidth: true, name: "ifscCode", size: "small", sx: {
                                "& .MuiInputBase-root": {
                                    backgroundColor: "#EFEFEF",
                                },
                            }, value: selecteFinalCharges.bankIfscCode })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { className: "m_form_label_font", variant: "body2", gutterBottom: true }, "UTR Number"),
                        React.createElement(TextField, { InputLabelProps: { shrink: false }, inputProps: { maxLength: 30, minLength: 2 }, placeholder: "XXXXXXXXXXXXXXXXXXXXXXX", fullWidth: true, name: "utrNumber", size: "small", sx: {
                                "& .MuiInputBase-root": {
                                    backgroundColor: "#EFEFEF",
                                },
                            }, value: utrNumber, onChange: (e) => setUtrNumber(e.target.value) })))),
            React.createElement(Button, { fullWidth: true, variant: "contained", sx: {
                    marginTop: 3,
                    marginBottom: 3,
                    textTransform: "none",
                    fontWeight: "bold",
                    padding: 1.5,
                    backgroundColor: primaryColor,
                    color: "#fff",
                }, onClick: handleSave }, "Save"))));
};
export default FinalChargesSliderbarPage;
